export default "/_next/static/images/modal-bottom-curve-texture-954c4ba29442999400c85b5e247f02c1.svg";